import React, { useEffect, useState } from 'react';
import loadClutch from './loadClutch';

export default function ClutchWidget() {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    loadClutch(() => {
      if (window.CLUTCHCO) {
        window.CLUTCHCO.Init();
        setLoaded(true);
      } else {
        console.error('Unable to load Clutch widget!');
      }
    });
  });
  return loaded ? (
    <div
      className="clutch-widget"
      data-url="https://widget.clutch.co"
      data-widget-type="1"
      data-height="40"
      data-theme="white"
      data-clutchcompany-id="42611"
    />
  ) : null;
}
